module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_236.25deg.dc6504cd.png";